export default {
	/**
	 * Set all users
	 * @param {Array} users 
	 */
	setUsers(state, users) {
		state.all = users
	},
}
